import { ArrowRightIcon, HelpCircleIcon } from 'lucide-react'
import { useContext } from 'react'

import AppConfigContext from 'components/context/AppConfigContext'
import { useEmbeddedOnboarding } from 'components/hooks/employer_onboarding/useEmbeddedOnboarding'
import { Modal, TextButton, TextLink } from 'slab'
import { getSupportLink } from 'utils/urls'

import { EmbeddedSupportLinkContent } from './EmbeddedSupportLinkContent'

export function SupportLink () {
  const { isEmbedded } = useEmbeddedOnboarding()
  const { environment } = useContext(AppConfigContext)
  const supportLink = getSupportLink(environment)

  return (
    <Modal
      trigger={
        <TextButton
          onClick={() => {
            window.segment?.track('[ER] AllowanceTool get help opened', {
              url: window.location.href,
              isEmbedded,
            })
          }}
          leftIcon={HelpCircleIcon}
          rightIcon={ArrowRightIcon}
          color='purple'
        >
          Need help or advice? Talk to an expert
        </TextButton>
      }
      width='small'
      aria-describedby={undefined}
    >
      <Modal.Header>
        <Modal.Title>Get support</Modal.Title>
      </Modal.Header>
      {isEmbedded
        ? <EmbeddedSupportLinkContent />
        : (
          <Modal.Body>
            <div>
              <div className='pb-2'>
                <h3 className='body-bold mb-1'>Want to talk to someone?</h3>
                <p>
                  <TextLink
                    href={supportLink}
                    onClick={() => {
                      window.segment?.track('[ER] AllowanceTool get support link clicked', {
                        url: window.location.href,
                      })
                    }}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Book a call with a member of our team.
                  </TextLink>
                </p>
              </div>
            </div>
          </Modal.Body>
          )}
    </Modal>
  )
}
